<template>
    <div>
        <div class="container-fluid container-fluid-publication">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="container">
                            <h1 class="category-title">{{ categoria }}</h1>
                            <h2 class="publication-title">{{ titulo }}</h2>
                            <div class="publication-description" v-html="descripcion"></div>
                            <p class="publication-system">{{ sistema }}</p>
                            <p class="publication-system-desc">{{ sistemadesc }}</p>
                            <template v-for="e in etiquetas">
                                <span class="publication-label-base">{{ e.nombre }}</span>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container container-resources">
            <div class="row">
                <div class="col-12">
                    <div class="container">
                        <h4 class="title-resources">Recursos</h4>
                        <div class="row">
                            <template v-for="r in recursos">
                                <div class="col-12">
                                    <div class="d-flex align-items-center container-file">
                                        <div class="d-flex justify-content-center">
                                            <span :class="'file-icon '+r.formato.extension">{{ r.formato.extension }}</span>
                                        </div>
                                        <div class="d-flex file-detail">
                                            <div>
                                                <h5 class="title-file">{{ r.titulo }}</h5>
                                                <small v-if="r.fecha_inicio" class="date-file-range">
                                                    {{ r.fecha_inicio | moment("L") }} - {{ r.fecha_final | moment("L") }}
                                                </small>
                                                
                                            </div>
                                        </div>
                                        <div class="d-flex justify-content-center">
                                            <b-button class="button-down" size="sm" variant="outline-primary" :href="r.url" target="_blank">
                                                <template v-if="r.formato.extension == 'json'">
                                                    Ver Recurso
                                                </template>
                                                <template v-else>
                                                    Descargar
                                                </template>
                                            </b-button>
                                        </div>
                                    </div>
                                    <!--
                                    <div 
                                        class="file-resumen" 
                                        v-if="r.resumen && r.formato.extension !== 'json'"
                                        v-html="r.resumen"
                                    >
                                    </div>
                                    
                                    <template v-if="r.resumen && r.formato.extension == 'json'">
                                        <b-button v-b-toggle="'collapse-' + r.id" class="m-1">¿Como consumir este recurso?</b-button>
                                        <b-collapse :id="'collapse-'+r.id" class="mt-2">
                                            <b-card>
                                                <div class="file-resumen" v-html="r.resumen"></div>
                                            </b-card>
                                        </b-collapse>
                                    </template>
                                    -->
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    

</template>

<script>
    import axios from 'axios'
    import configService from '../services/config'

	export default {
		name: 'publicationdetail',
		props: [
            'idpublicacion',
        ],
		data() {
			return {
                titulo: null,
                descripcion: null,
                categoria: null,
                sistema: null,
                sistemadesc: null,
                etiquetas: null,
                recursos: null

			}
		},
        mounted () {
            this.getPub ();
        },
        methods: {
            getPub () {
                axios
                    .get(configService.apiUrl+'publicaciones/'+this.idpublicacion)
                        .then( response => {
                            this.titulo = response.data.titulo,
                            this.descripcion = response.data.descripcion,
                            this.categoria = response.data.categoria.nombre,
                            this.sistema = response.data.sistema.nombre,
                            this.sistemadesc= response.data.sistema.descripcion,
                            this.etiquetas= response.data.etiquetas
                            this.recursos= response.data.recursos
                        })
                        .catch( e => console.log(e))
            }
        }
	}
</script>

<style lang="scss" scoped>
    @import '../scss/abstracts/variables';
    @import '../scss/components/publication';
    @import '../scss/base/titles';

    .container-fluid-publication {
        text-align: center;
        background: #f8f9fa;
        padding: 1rem;

        @include media-breakpoint-up(sm) {      
            padding: 2rem;
        }

        .publication-description,
        .publication-system {
            font-family: $font-01;
            font-size: 0.7rem;
            @include media-breakpoint-up(sm) {      
                font-size: 1rem;
            }
        }

        .publication-system-desc {
            font-size: 0.6rem;
            font-family: $font-02;
            @include media-breakpoint-up(sm) {      
                font-size: 0.7rem;
            }
        }
        .publication-label-base {
            font-size: 0.5rem !important;
            @include media-breakpoint-up(sm) {      
                font-size: 0.6rem !important;
            }
        }

    }

    .container-resources {
        margin-bottom: 3rem;
    }

    .container-file {
        padding: 1rem;
    }
    .file-icon {
        width: 35px;
        font-size: 0.5rem !important;
        padding: 0.1rem 0.3rem;
        @include media-breakpoint-up(sm) {      
            width: 50px;
            font-size: 0.6rem !important;
            padding: 0.1rem 0.5rem;
        }
        
        
    }
    .file-detail {
        width: 80% !important;
        padding-left: 0.5rem;
        padding-right: 0.5rem;

        .title-file,
        .date-file-range,
        .file-resumen {
            margin-bottom: 0;
        }
        .title-file {
            font-size: 0.6rem;
            font-family: $font-01;
            font-weight: 300;
            @include media-breakpoint-up(sm) {      
                font-size: 0.9rem;
            }
        }
        .date-file-range {
            color: $color-3;
            font-size: 0.7rem;
        }

        .file-resumen {
            font-family: $font-02;
            font-size: 0.85rem;
            
        }
        .file-resumen > pre {
            background: #e0e0e0;
            /* color: white; */
            border: 1px solid #b7b7b7;
            padding: 0.2rem 0.3rem 0 0.3rem;
            border-radius: 2px;
        }
    }
    .button-down {
        border-color: $color-3;
        color: $color-3;
        font-size: 0.5rem;
        @include media-breakpoint-up(sm) {      
            font-size: 0.8rem;
        }

        &:hover {
            background: $color-3;
            color: $color-bg-dark;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/PublicationDetail.vue